module.exports = __webpack_public_path__ + "media/images/lp/industries/bg_outline-circle-f83a192fb03018f33a58b72a62cb2544.svg";